export const BundleMockup = () => (
  <div data-testid="bundle-mockup" className="relative flex items-end justify-center">
    <div className="relative z-10 mb-8 hidden w-36 rotate-[-6deg] overflow-hidden rounded-lg border border-white/15 shadow-[0_30px_60px_rgba(0,0,0,0.7)] sm:block md:w-44">
      <img src="/assets/book-becoming-her.jpg" alt="Becoming Her Blueprint — digital book by Dasha Love" loading="lazy" className="block w-full" />
    </div>

    <div className="relative z-20 w-[300px] sm:w-[440px]">
      <div className="rounded-t-2xl border border-white/15 bg-[#0d0d0d] p-2 shadow-[0_40px_80px_rgba(0,0,0,0.7)]">
        <div className="flex aspect-[16/10] flex-col overflow-hidden rounded-lg bg-ink p-4 sm:p-5">
          <div className="flex gap-1.5">
            <span className="h-2 w-2 rounded-full bg-white/15" />
            <span className="h-2 w-2 rounded-full bg-white/15" />
            <span className="h-2 w-2 rounded-full bg-lime/60" />
          </div>
          <p className="mt-3 font-serif text-base italic text-lime sm:text-xl">Wild Woman Millions™</p>
          <p className="font-mono text-[8px] tracking-[0.3em] text-cream/40 sm:text-[9px]">VISION → BLUEPRINT → QUANTUM HABITS → CAPACITY → CURRENCY</p>
          <div className="mt-4 space-y-2">
            {["01 VISION", "02 BLUEPRINT", "03 QUANTUM HABITS", "04 CAPACITY"].map((m) => (
              <div key={m} className="flex items-center gap-2 rounded border border-white/10 bg-white/[0.03] px-2.5 py-1.5">
                <span className="font-mono text-[8px] text-lime sm:text-[9px]">{m.slice(0, 2)}</span>
                <span className="font-mono text-[8px] tracking-[0.12em] text-cream/70 sm:text-[9px]">{m.slice(3)}</span>
              </div>
            ))}
          </div>
          <div className="mt-auto h-1 overflow-hidden rounded bg-white/10">
            <div className="h-full w-2/3 rounded bg-lime" />
          </div>
        </div>
      </div>
      <div className="mx-[-8px] h-3 rounded-b-2xl border-x border-b border-white/10 bg-[#1c1c1c]" />
    </div>

    <div className="relative z-30 -ml-10 mb-3 w-24 rotate-[5deg] animate-floaty rounded-[1.6rem] border border-white/15 bg-black p-1.5 shadow-[0_30px_60px_rgba(0,0,0,0.7)] sm:-ml-14 sm:w-32">
      <div className="overflow-hidden rounded-[1.2rem]">
        <img src="/assets/book-stop-hiding.jpg" alt="Stop F*cking Hiding — digital book by Dasha Love" loading="lazy" className="block w-full" />
      </div>
    </div>

    <div className="absolute -right-2 top-0 z-0 hidden w-32 rotate-[8deg] overflow-hidden rounded-lg border border-white/15 shadow-[0_30px_60px_rgba(0,0,0,0.7)] md:block lg:-right-8 lg:w-40">
      <img src="/assets/book-paid-for-being-you.jpg" alt="Paid For Being You — Million Dollar Momentum Planner by Dasha Love" loading="lazy" className="block w-full" />
    </div>
  </div>
);
